module.exports = __webpack_public_path__ + "img/img38.495dcdf8.png";